import { Alert, AlertIcon, Box, Text } from '@chakra-ui/react';
import RoutableModal from 'components/general/RoutableModal';
import { useLocationCreateMutation } from 'generated/graphql';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import LocationForm from '../LocationForm';
import { updateCacheOnCreate } from './lib';

type FormData = {
  name: string;
  address: string;
  maxSuites: number;
};

function NewLocation() {
  const form = useForm<FormData>();
  const navigate = useNavigate();
  const goBack = () => navigate('..');
  const [createLocation, { loading, error }] = useLocationCreateMutation({
    update: updateCacheOnCreate,
    onCompleted: goBack,
  });

  const handleSubmit = form.handleSubmit(data => {
    createLocation({ variables: { data } });
  });

  return (
    <RoutableModal
      title="New Location"
      buttons={{ action: { text: 'Save', handler: handleSubmit } }}
      loading={loading}
    >
      <Box mb={8}>
        <Text mb={2}>Please enter the required information to create a new location</Text>
        {!!error && (
          <Alert status="error" variant="left-accent">
            <AlertIcon />
            {error.message}
          </Alert>
        )}
      </Box>
      <FormProvider {...form}>
        <LocationForm />
      </FormProvider>
    </RoutableModal>
  );
}

export default NewLocation;
